var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';
import { Progress } from '../../../Progress';
import { Icon } from '../../../Icon';
import { Typography } from '../../../Typography';
import "./styles.css";
import cn from 'classnames';
export var FileUploaderListItem = function (_a) {
    var name = _a.name, _b = _a.state, state = _b === void 0 ? 'upload' : _b, onRefresh = _a.onRefresh, onRemove = _a.onRemove, iconName = _a.iconName, id = _a.id, type = _a.type, className = _a.className, props = __rest(_a, ["name", "state", "onRefresh", "onRemove", "iconName", "id", "type", "className"]);
    var handleRefresh = function () {
        onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh({ id: id, name: name, state: state, iconName: iconName, type: type });
    };
    var handleRemove = function () {
        onRemove === null || onRemove === void 0 ? void 0 : onRemove({ id: id, name: name, state: state, iconName: iconName, type: type });
    };
    return (React.createElement("div", __assign({ className: cn('lk-ui_file-uploader-file-description', className) }, props),
        React.createElement("span", { className: 'lk-ui_file-uploader-file_name' },
            React.createElement("span", { className: 'lk-ui_file-uploader-file-icon' },
                state === 'process' && (React.createElement(Progress, { shape: 'circle', cycled: true, strokeWidth: 2, size: 24, value: 75 })),
                state === 'upload' && (React.createElement(Icon, { iconName: iconName || Icons.Page, size: 'large', type: 'default' })),
                state === 'error' && (React.createElement(Icon, { iconName: iconName || Icons.Page, size: 'large', type: 'error' }))),
            React.createElement(Typography, { variant: 'body2', className: 'lk-ui_file-uploader-file_name-text' }, name)),
        state === 'error' && (React.createElement("span", { className: 'lk-ui_file-uploader-file-refresh' },
            React.createElement(Icon, { iconName: Icons.Refresh, size: 'large', onClick: handleRefresh }))),
        React.createElement("span", { className: 'lk-ui_file-uploader-file-delete' },
            React.createElement(Icon, { iconName: Icons.Close, size: 'large', onClick: handleRemove }))));
};
